import Icon from '@ant-design/icons';

const LogoutSvg = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.1396 0.25H2.86163C1.41963 0.25 0.250634 1.417 0.249634 2.859V2.861V8.083H2.86163V2.861H21.1396V21.14H2.86163V15.917H0.249634V21.14C0.249634 22.582 1.41863 23.75 2.86063 23.75H2.86163H21.1396C22.5786 23.745 23.7446 22.58 23.7496 21.14V2.861C23.7456 1.421 22.5796 0.255 21.1396 0.25ZM9.50663 16.688L11.3496 18.529L17.8776 12.001L11.3496 5.472L9.50863 7.313L12.8766 10.695H0.249634V13.306H12.8746L9.50663 16.688Z" fill="#4B5DB8"/>
    </svg>
)

export const LogoutIcon = props => <Icon component={LogoutSvg} {...props} />;